export const AUTH_ENDPOINTS = {
    IDENTITY_LOGIN: "/Auth/login",
    REGISTER: "/InfluencerLogin/InfluencerRegisterRequest",
    KLAVIYO_REGISTER: "/Klaviyo/Register",
    FORGOT_PASSWORD: "/UserDetails/SendPasswordResetEmail",
    RESET_PASSWORD: "/UserDetails/ResetPassword",
    SEND_ORDER_CONFIRMATION: "/UserDetails/SendOrderConfirmation",
    TURNSTILE_VERIFY: "/turnstile/verify",
};
